export default {"src":"/coding-school/_next/static/media/edly-ai.5bc8d3ba.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};